import TextField from '@material-ui/core/TextField';

import { Autocomplete, createFilterOptions } from '@mui/material';
import { Field } from 'formik';
// import { fieldToTextField } from 'formik-mui';

import { useStyles } from './styles';

const fieldToTextField = ({ field, form, ...props }) => {
  const { name } = field;
  const { touched, errors } = form;

  const error = Boolean(touched[name] && errors[name]);
  const helperText = touched[name] && errors[name] ? errors[name] : '';

  return {
    ...field,
    error,
    helperText,
    ...props,
  };
};

const FormikAutocomplete = ({ textFieldProps, value, disabled, onChange, ...props }) => {
  const classes = useStyles();

  const {
    form: { setTouched, setFieldValue },
  } = props;

  const { error, helperText, ...field } = fieldToTextField(props); // Use a função customizada
  const { name, label } = field;

  const OPTIONS_LIMIT = 5;
  const defaultFilterOptions = createFilterOptions();

  const filterOptions = (options, state) => {
    return defaultFilterOptions(options, state).slice(0, OPTIONS_LIMIT);
  };

  return (
    <Autocomplete
      {...props}
      {...field}
      openText='Abrir'
      closeText='Fechar'
      noOptionsText='Sem opções'
      loadingText='Carregando'
      disablePortal
      filterOptions={filterOptions}
      value={value}
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      onChange={(_, newValue) => setFieldValue(name, newValue)} // Descomente para funcionalidade
      onBlur={() => setTouched({ [name]: true })} // Descomente para funcionalidade
      disabled={disabled}
      renderInput={(props) => (
        <TextField
          {...props}
          {...textFieldProps}
          helperText={helperText}
          error={error}
          label={label}
          className={classes.customInput}
        />
      )}
    />
  );
};

const CustomAutocomplete = ({ name, label, filteredValues, value, disabled, onChange }) => (
  <>
    <Field
      name={name}
      component={FormikAutocomplete}
      label={label}
      options={filteredValues}
      value={value || ''} // Mantenha isso para o valor do campo
      disabled={disabled}
      textFieldProps={{
        fullWidth: true,
        variant: 'outlined',
      }}
      onChange={onChange} // Passa o onChange aqui
    />
  </>
);

export { CustomAutocomplete };
